<section class="task-config__time-wrapper">
    <mat-form-field appearance="fill">
        <mat-label>{{ props.label || 'Time' }}</mat-label>
        <input [formControl]="timeControl" [step]="step" matInput type="time" />
        @if (!!props.description) {
            <mat-hint>{{ props.description }}</mat-hint>
        }
        @if (!!timeControl.errors) {
            <mat-error>
                @if (timeControl.hasError('required')) {
                    This field is required.
                }
                @if (!timeControl.hasError('required')) {
                    @if (timeControl.hasError('invalidTimeFormat')) {
                        {{ timeControl.getError('invalidTimeFormat') }}
                    }
                }
            </mat-error>
        }
    </mat-form-field>
</section>
